(function () {
  var i18n = window.wpdSignupI18n;
  if (!i18n) return;

  function cleanLabel(text) {
    return (text || '').replace(/\s+/g, ' ').replace(/\s*\*\s*$/, '').trim();
  }

  function isRequired(text) {
    return (text || '').indexOf('*') !== -1;
  }

  function findFieldByLabel(text) {
    var labels = document.querySelectorAll('#wpdMainContainer .wpd-signup-field label');
    for (var i = 0; i < labels.length; i++) {
      if (cleanLabel(labels[i].textContent) === text) {
        return labels[i].closest('.wpd-signup-field');
      }
    }
    return null;
  }

  function findSectionByHeader(text) {
    var headers = document.querySelectorAll('#wpdMainContainer .wpd-secondary-header');
    for (var i = 0; i < headers.length; i++) {
      if (headers[i].textContent.trim() === text) {
        return { header: headers[i], section: headers[i].closest('div[id$="Wrapper"]') || headers[i].parentElement };
      }
    }
    return null;
  }

  function moveIcoNextToTaxId() {
    var taxId = findFieldByLabel('Tax ID');
    var ico = findFieldByLabel('IČO') || findFieldByLabel('ICO');
    if (!taxId || !ico || !taxId.parentNode) return;
    taxId.parentNode.insertBefore(ico, taxId.nextSibling);
  }

  // IČO is a Czech/Slovak company number — hide it everywhere else (DE, AT, …).
  function hideIcoOutsideCzSk() {
    if (i18n.country_iso_code === 'CZ' || i18n.country_iso_code === 'SK') return;
    var ico = findFieldByLabel('IČO') || findFieldByLabel('ICO');
    if (ico) ico.style.display = 'none';
  }

  function hideEmptySections() {
    document.querySelectorAll('#wpdMainContainer [id$="Wrapper"]').forEach(function (section) {
      if (!section.querySelector('.wpd-secondary-header')) return;
      var fields = section.querySelectorAll('.wpd-signup-field');
      if (fields.length === 0) section.style.display = 'none';
    });
  }

  var sectionMap = {
    'Primary Contact Details': i18n.primary_contact,
    'Business Details': i18n.business_details,
    'More Details': i18n.more_info,
    'More Information': i18n.more_info,
    'Additional Details': i18n.more_info,
    'Additional Information': i18n.more_info
  };

  var labelMap = {
    'First name': i18n.fields.first_name_label,
    'Last name': i18n.fields.last_name_label,
    'Email': i18n.fields.email_label,
    'Title': i18n.fields.title_label,
    'Address line 1': i18n.fields.address1_label,
    'Address line 2': i18n.fields.address2_label,
    'City': i18n.fields.city_label,
    'Postal Code': i18n.fields.postal_label,
    'Country': i18n.fields.country_label,
    'Company Name': i18n.fields.company_name_label,
    'Website': i18n.fields.website_label,
    'Phone': i18n.fields.phone_label,
    'Tax ID': i18n.fields.tax_id_label
  };

  var placeholderMap = {
    'First name': i18n.fields.first_name_placeholder,
    'Last name': i18n.fields.last_name_placeholder,
    'you@companyname.com': i18n.fields.email_placeholder,
    'Eg. Owner, Manager': i18n.fields.title_placeholder,
    'Street, Main etc': i18n.fields.address1_placeholder,
    'Apartment, suite, etc': i18n.fields.address2_placeholder,
    'City': i18n.fields.city_placeholder,
    'Postal Code': i18n.fields.postal_placeholder,
    'Company Name': i18n.fields.company_name_placeholder,
    'Website': i18n.fields.website_placeholder,
    'Phone': i18n.fields.phone_placeholder,
    'Tax ID': i18n.fields.tax_id_placeholder
  };

  function translateSectionHeaders() {
    document.querySelectorAll('#wpdMainContainer .wpd-secondary-header').forEach(function (el) {
      var key = el.textContent.trim();
      if (sectionMap[key]) el.textContent = sectionMap[key];
    });
  }

  function translateLabels() {
    document.querySelectorAll('#wpdMainContainer .wpd-signup-field label').forEach(function (label) {
      var key = cleanLabel(label.textContent);
      var translated = labelMap[key];
      if (translated) {
        label.textContent = isRequired(label.textContent) ? translated + ' *' : translated;
      }
    });
  }

  function translatePlaceholders() {
    document.querySelectorAll('#wpdMainContainer .wpd-signup-field input[placeholder], #wpdMainContainer .wpd-signup-field textarea[placeholder]').forEach(function (input) {
      var translated = placeholderMap[input.placeholder];
      if (translated) input.placeholder = translated;
    });
  }

  function findSubmitButton() {
    var byId = document.querySelector('#wpdSignupBtn, #wpdSignupButton, #wpdSubmitBtn, #wpdSignupSubmitBtn, .wpd-signup-submit, .wpd-submit-button');
    if (byId) return byId;
    var candidates = document.querySelectorAll('button, input[type="submit"], input[type="button"]');
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      var text = (el.tagName === 'INPUT' ? el.value : el.textContent).trim();
      if (text === 'Submit' && !el.closest('header, nav, .header, .menu-drawer, .search-modal, .cart-drawer, localization-form')) {
        return el;
      }
    }
    return null;
  }

  function translateSubmit() {
    var submit = findSubmitButton();
    if (!submit) return;
    submit.classList.add('wpd-signup-submit-styled');
    submit.style.setProperty('background-color', '#5EB130', 'important');
    submit.style.setProperty('color', '#FFFFFF', 'important');
    submit.style.setProperty('border-color', '#5EB130', 'important');
    if (!i18n.submit) return;
    if (submit.tagName === 'INPUT') submit.value = i18n.submit;
    else submit.textContent = i18n.submit;
  }

  var THANK_YOU_PATTERNS = [
    'thank you for choosing',
    'thank you for becoming',
    'review your application'
  ];

  function textMatchesThankYou(text) {
    if (!text) return false;
    var lower = text.toLowerCase();
    for (var i = 0; i < THANK_YOU_PATTERNS.length; i++) {
      if (lower.indexOf(THANK_YOU_PATTERNS[i]) !== -1) return true;
    }
    return false;
  }

  function buildThankYouMarkup() {
    return '<div class="wpd-thank-you__card">' +
        '<div class="wpd-thank-you__icon" aria-hidden="true">' +
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
            '<path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>' +
            '<polyline points="22 4 12 14.01 9 11.01"></polyline>' +
          '</svg>' +
        '</div>' +
        '<h2 class="wpd-thank-you__heading">' + (i18n.thank_you_heading || '') + '</h2>' +
        '<p class="wpd-thank-you__message">' + (i18n.thank_you_message || '') + '</p>' +
      '</div>';
  }

  var thankYouRendered = false;

  function renderThankYouInto(target) {
    if (!target || target.dataset.wpdThankYouRendered === '1') return;
    target.dataset.wpdThankYouRendered = '1';
    target.classList.add('wpd-thank-you');
    target.style.display = '';
    target.removeAttribute('hidden');
    target.innerHTML = buildThankYouMarkup();
  }

  function findThankYouHost() {
    var container = document.getElementById('wpdMainContainer');
    if (container && textMatchesThankYou(container.textContent)) return container;

    var successWrap = document.getElementById('wpdSuccessMessageWrapper');
    if (successWrap && (successWrap.offsetParent !== null || textMatchesThankYou(successWrap.textContent))) {
      return successWrap;
    }

    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var p = n.parentNode;
        if (p && (p.tagName === 'SCRIPT' || p.tagName === 'STYLE')) {
          return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var node;
    while ((node = walker.nextNode())) {
      if (textMatchesThankYou(node.nodeValue)) {
        var el = node.parentElement;
        while (el && el !== document.body) {
          if (el.id === 'wpdMainContainer' || /(wholesale|wpd|signup|thank|success)/i.test(el.className || '')) {
            return el;
          }
          el = el.parentElement;
        }
        return node.parentElement;
      }
    }
    return null;
  }

  function hideOtherThankYouElements(keep) {
    var nodes = document.querySelectorAll('.wpd-thank-you, .wpd-thank-you__card, #wpdSuccessMessageWrapper, #wpd_power_by_wrapper');
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (n === keep || keep.contains(n) || n.contains(keep)) continue;
      n.style.display = 'none';
    }
  }

  function tryRenderThankYou() {
    if (thankYouRendered) return true;
    var host = findThankYouHost();
    if (!host) return false;
    var target = host;
    if (host.id !== 'wpdMainContainer') {
      var main = document.getElementById('wpdMainContainer');
      if (main) {
        renderThankYouInto(main);
        host.style.display = 'none';
        target = main;
        thankYouRendered = true;
        hideOtherThankYouElements(target);
        return true;
      }
    }
    renderThankYouInto(host);
    thankYouRendered = true;
    hideOtherThankYouElements(target);
    return true;
  }

  function apply() {
    var container = document.getElementById('wpdMainContainer');
    if (!container) return;

    if (tryRenderThankYou()) return;

    var heading = document.getElementById('wpdMainHeader');
    if (heading && i18n.header) heading.textContent = i18n.header;

    var help = document.querySelector('#wpdHelpTextWrapper .wpd-secondary-text');
    if (help && i18n.intro) help.textContent = i18n.intro;

    moveIcoNextToTaxId();
    hideIcoOutsideCzSk();
    hideEmptySections();
    translateSectionHeaders();
    translateLabels();
    translatePlaceholders();
    translateSubmit();
  }

  function observeForThankYou() {
    if (thankYouRendered) return;
    var observer = new MutationObserver(function () {
      if (thankYouRendered) { observer.disconnect(); return; }
      if (tryRenderThankYou()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  var ERROR_PATTERNS = [
    /please\s+fill\s+(all|in)\s+the\s+(mandatory|required)\s+fields/i,
    /please\s+fill\s+(all|in)\s+(all\s+)?(mandatory|required)\s+fields/i,
    /fill\s+(all|in)\s+(mandatory|required)\s+fields/i
  ];

  function textMatchesError(text) {
    if (!text) return false;
    for (var i = 0; i < ERROR_PATTERNS.length; i++) {
      if (ERROR_PATTERNS[i].test(text)) return true;
    }
    return false;
  }

  function translateErrors() {
    if (!i18n.mandatory_fields_error) return;
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var p = n.parentNode;
        if (p && (p.tagName === 'SCRIPT' || p.tagName === 'STYLE')) {
          return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var node;
    while ((node = walker.nextNode())) {
      if (textMatchesError(node.nodeValue)) {
        node.nodeValue = i18n.mandatory_fields_error;
      }
    }
  }

  function observeForErrors() {
    var observer = new MutationObserver(translateErrors);
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  function init() {
    apply();
    observeForThankYou();
    observeForErrors();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
